import { JSX } from 'react'

interface ILoaderWrapper {
  children: JSX.Element
}

export const DefaultLoaderWrapper = ({ children }: ILoaderWrapper) => children
